import { daysToEvent } from './daysToEvent';

export function daysFromEvent(date?: string | null) {
  const result = daysToEvent(date);

  if (!result) {
    return;
  }

  const invertedResult = parseInt(result, 10) * -1;

  return invertedResult.toString();
}
